/**
 * include bottom menu content to body dom
 * @requires  bottom_menu.mod  jQuery  Vue
 * need stylesheet: common_component.css, css/bottom_menu.css
 */
import bottomMenuContent from '../../html/content_module/bottom_menu.mod';
import Link from '../../common/prefixName';
import externalApp from '../../data/externalApp';
var apiBaseUri = Link.prefix.realmName;
app.init(appConfig);


/* module config */

var moduleConfig = {
    apiConfig : {
        'message_unread_cound' : {
            url : apiBaseUri + 'portal/mycenter/message/unread_count',
            method : 'post',
            error : app.config.ajaxErrorLogHandle
        }
    }
}

/* end module config */

$(document.body).append(bottomMenuContent);

(function (){
    if (location.href.indexOf('html/home/index.html') >= 0)
    {
        $('.bottom_menu .menuItem:eq(0)').addClass('active');
        $('.bottom_menu .menuItem:eq(0) a').addClass('colorFFA724');

    }
    else if (location.href.indexOf('/html/atlas') >= 0)
    {
        $('.bottom_menu .menuItem:eq(1)').addClass('active');
        $('.bottom_menu .menuItem:eq(1) a').addClass('colorFFA724');
    }
    else if (location.href.indexOf('html/download') >= 0)
    {
        $('.bottom_menu .menuItem:eq(2)').addClass('active');
        $('.bottom_menu .menuItem:eq(2) a').addClass('colorFFA724');
    }
    // else if (location.href.indexOf('html/atlas/') >= 0)
    // {
    //     $('.bottom_menu .menuItem:eq(3)').addClass('active');
    //     $('.bottom_menu .menuItem:eq(3) a').addClass('colorFFA724');
    // }
    else if (location.href.indexOf('html/me/') >= 0)
    {
        $('.bottom_menu .menuItem:eq(3)').addClass('active');
        $('.bottom_menu .menuItem:eq(3) a').addClass('colorFFA724');
    }
})();

new Vue({
    el: '#bottom_menu',
    data(){
        return {
            flag: false,
            mePageNewCount : 0,
            externalApp : externalApp
        }
    },
    methods: {
        openThis() {
            this.flag = true
            document.body.parentNode.style.overflowY = 'hidden';
        },
        closeThis(){
            this.flag = false
            document.body.parentNode.style.overflowY = 'auto';
        },
        toInformation(){
            window.location.href = '../../html/article/edit.html'
        },
        toVideo(){
            window.location.href = '../quan/releaseMeng.html'
        },
        toBecomeTeacher(){
            window.location.href = '../me/teacherUpgrade.html'
        }
    },
    created : function (){

        var me = this;
        // $.ajax({
        //     url : moduleConfig.apiConfig.message_unread_cound.url,
        //     type : moduleConfig.apiConfig.message_unread_cound.method || 'get',
        //     data : moduleConfig.apiConfig.message_unread_cound.params || {},
        //     success : function (result){
        //         me.mePageNewCount = result['data'];
        //     },
        //     error : app.config.ajaxErrorLogHandle
        // });

        // use simple function
        // loadDataFromApiToObject(moduleConfig.apiConfig.message_unread_cound, this, ['mePageNewCount'], ['data'])
    }
});



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/content_module/bottom_menu.js
 **/